'use strict';

(function(global) {

  /**
   * Класс, определяющий принадлежность документа к определённому типу.
   *
   * @since 5.7.0
   */
  class DataType {

    constructor(extension, isImage, pageCount) {
      this._extension = extension;
      this._isImage = isImage;
      this._isMultipage = pageCount > 1;
    }

    /**
     * Флаг, является ли документ изображением.
     *
     * @property isImage
     * @return {boolean} TRUE - если документ является изображением, иначе - FALSE.
     */
    get isImage() {
      return this._isImage;
    }

    /**
     * Флаг, является ли документ таблицей.
     *
     * @property isSpreadsheet
     * @return {boolean} TRUE - если документ является таблицей, иначе - FALSE.
     */
    get isSpreadsheet() {
      return !this._isImage && ['XLS', 'XLSX', 'CSV', 'ODS', 'XLSM'].includes(this._extension);
    }

    /**
     * Флаг, является ли документ текстом.
     *
     * @property isText
     * @return {boolean} TRUE - если документ является текстом, иначе - FALSE.
     */
    get isText() {
      return !this._isImage && ['DOC', 'DOCX', 'RTF', 'ODT', 'TXT', 'DPAD', 'MSG', 'OFT'].includes(this._extension);
    }

    /**
     * Флаг, является ли документ многостраничным (есть разбиение на слайды/страницы, как в PDF и PPT).
     *
     * @property isMultipage
     * @return {boolean} TRUE - если документ является многостраничным, иначе - FALSE.
     */
    get isMultipage() {
      return this._isMultipage;
    }

    /**
     * Флаг, является ли документ сконвертированным из Word-документа.
     *
     * @property wasMadeFromMsWordDocument
     * @return {boolean} TRUE - если документ является текстом, иначе - FALSE.
     */
    get wasMadeFromMsWordDocument() {
      return ['DOC', 'DOCX', 'RTF', 'ODT'].includes(this._extension);
    }

    /**
     * Поддерживается ли для документа изменение масштаба?
     *
     * @property isScalable
     * @return {boolean}
     */
    get isScalable() {
      return ['DOC', 'DOCX', 'RTF', 'ODT', 'TXT'].includes(this._extension);
    }
  }

  global.DataType = DataType;

})(window.Core.preview);
